// @ts-nocheck
import React, { useState } from 'react';
import { SortAsc, SortDesc, Inbox, ArrowUpDown, ChevronDown } from 'lucide-react';
import NewTicketCard from './new-ticket-card/NewTicketCard';
import { SkeletonSwitch } from 'skeleton';
import { TicketListSkeleton } from "../../skeleton/support/SupportSkeleton"
import { isDevMode } from 'lib/featureFlags';
import { SelectField } from "components/ui/select-field";

const CustomerTicketList = ({ tickets, onTicketClick, supportData, loading }) => {
  const [sortBy, setSortBy] = useState('newest');

  // Sort tickets (filtering is handled by CustomerFilters component)
  const sortedTickets = [...tickets].sort((a, b) => {
    switch (sortBy) {
      case 'newest':
        return new Date(b.createdAt) - new Date(a.createdAt);
      case 'oldest':
        return new Date(a.createdAt) - new Date(b.createdAt);
      case 'updated':
        return new Date(b.updatedAt) - new Date(a.updatedAt);
      case 'priority':
        const priorityOrder = { critical: 4, high: 3, medium: 2, low: 1 };
        return priorityOrder[b.priority] - priorityOrder[a.priority];
      default:
        return new Date(b.createdAt) - new Date(a.createdAt);
    }
  });

  const sortOptions = [
    { value: 'newest', label: 'Newest First', icon: SortDesc },
    { value: 'oldest', label: 'Oldest First', icon: SortAsc },
    { value: 'updated', label: 'Recently Updated', icon: SortDesc },
    { value: 'priority', label: 'Priority', icon: SortDesc }
  ];

  if (tickets.length === 0) {
    return (
      <div className="rounded-2xl border border-line dark:border-white/[0.07] bg-surface dark:bg-dark-800 p-12 text-center">
        <div className="w-16 h-16 rounded-2xl bg-gray-100 dark:bg-white/[0.06] flex items-center justify-center mx-auto mb-4">
          <Inbox className="w-8 h-8 text-content-subtle dark:text-gray-500" />
        </div>
        <h3 className="text-base font-semibold text-content dark:text-white mb-2">No tickets found</h3>
        <p className="text-sm text-content-muted dark:text-gray-400">
          No tickets match your current filters. Try adjusting your search or filter criteria.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {/* Header with Sort Options */}
      {isDevMode() && (
        <div className="flex items-center justify-between px-1">
          <p className="text-xs font-semibold uppercase tracking-wide text-content-muted dark:text-gray-500">
            {tickets.length} ticket{tickets.length !== 1 ? 's' : ''}
          </p>
          <div className="flex items-center gap-2">
            <ArrowUpDown className="w-3.5 h-3.5 text-content-subtle dark:text-gray-500" />
            <div className="relative">
              <SelectField
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="pl-3 pr-8 py-1.5 bg-surface dark:bg-dark-800 border border-line dark:border-white/[0.07] rounded-xl text-xs font-semibold text-gray-700 dark:text-gray-300 focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 appearance-none cursor-pointer transition-colors"
              >
                {sortOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </SelectField>
              <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-content-subtle pointer-events-none" />
            </div>
          </div>
        </div>
      )}

      <SkeletonSwitch isLoading={loading} skeleton={<TicketListSkeleton />}>
        <div className="space-y-2.5">
          {supportData?.data?.map(ticket => (
            <div key={ticket.id}>
              <NewTicketCard
                ticket={ticket}
                onClick={onTicketClick}
                showCustomerInfo={false}
              />
            </div>
          ))}
        </div>
      </SkeletonSwitch>
    </div>
  );
};

export default CustomerTicketList;
